import { whitelistUser } from "./states";

export const services = {
  whitelistUser,
};
